import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from '../../config/urls';

const BASE_ENDPOINT = '/crc';

const certificateEndpoints = {
    saveCertificate: (payload) => stipAxios.post(`${BASE_ENDPOINT}/save`, payload),
    getCertificate: (cdCertificado) => stipAxios.get(`${BASE_ENDPOINT}/${cdCertificado}`),
    getCertificates: (cdSolicitacao) => stipAxios.get(`${BASE_ENDPOINT}/find/${cdSolicitacao}`),
    getEmissionDate: (param) => stipAxios.post(`${BASE_ENDPOINT}/dtemissao`, { ...param }),
    getExpirationDate: (param) => stipAxios.post(`${BASE_ENDPOINT}/dtvencimento`, { ...param }),
    signCertificate: (payload) => stipAxios.put(`${BASE_ENDPOINT}/assinar`, payload),
    signListCertificate: (payload) => stipAxios.post(`${BASE_ENDPOINT}/assinar-lista`, payload),
    getLineCertificates: (cdLinha) => stipAxios.get(`${EXTERNAL_CONTEXT}/solicitacao/linha/certificados/${cdLinha}`),
};

export default certificateEndpoints;
